package com.example.mystybag.core.logic.helpers

import com.example.mystybag.core.model.LinkModel

class DialogResult(private val resultType: DialogResultType, private val data: Any? = null) {

    fun onPositiveClick(action: () -> Unit): DialogResult {
        if (resultType == DialogResultType.POSITIVE)
            action()

        return this
    }

    fun onNegativeClick(action: () -> Unit): DialogResult {
        if (resultType == DialogResultType.NEGATIVE)
            action()

        return this
    }

    fun onCanceled(action: () -> Unit): DialogResult {
        if (resultType == DialogResultType.CANCELED)
            action()

        return this
    }

    fun onLinkTextClick(action: (LinkModel?) -> Unit): DialogResult {
        if (resultType == DialogResultType.LINK_TEXT)
            action(data as? LinkModel)

        return this
    }
}